<template>
  <div id="dataExport">
    <div class="header">
      <el-row style="height: 40px; line-height: 40px">
        <el-col :span="24">
          <el-form>
            <el-row>
              <el-col :span="12" style="text-align: left;">
                <span style="font-weight: bold;display: inline-block;width: 70px">任务列表</span>
                <el-select v-model="searchForm.task_id" placeholder="请选择任务" style="width: calc(100% - 160px)" clearable
                  @change="handleTaskChange" size="small">
                  <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name" :value="item.task_id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="12" style="text-align: right">
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="buttonArr">
        <el-button @click="downloadDetail()"
          style="margin-top: 20px; margin-left: 0; margin-right: 15px" type="primary" size="small"
          icon="el-icon-download">
          数据采集下载
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
  import http from '../../../APIService/http'
  import moment from "moment";

export default {
  name: "dataExport",
  data() {
    let that = this;
    return {
      taskList: [],
      searchForm: {
        task_id: "",
      },
    };
  },
  async created() {
    await this.getCollectTask()
  },
  methods: {
    async getCollectTask() {
      let loading1 = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
        }
        await http.post('/crm/web/collection/getCollectionTaskArray', data).then(res => {
          debugger
          if (res.success) {
            this.taskList = res.data
            if (this.taskList.length > 0) {
              this.searchForm.task_id = this.taskList[0].task_id
            }
            loading1.close()
          } else {
            Message.error(res.message);
          }
        })
      } catch (e) {
        loading1.close()
      }
    },
    handleTaskChange(val) {
      console.log(val)
      if (val) {
        this.searchForm.task_id = val
      }
    },
    async downloadDetail() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let user = this.$store.getters.getUser;
      let params = {};
      params.tenant_id = user.tenant_id;
      params.task_id = this.searchForm.task_id;
      debugger
      await axios({
        method: "post",
        url: "/wapi/derive/exportLuoshiNimingData",
        data: params,
        responseType: 'arraybuffer'
        // responseType: "blob",
      })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          }); //然后创建blob对象，文件类型设置为excel的类型{type: "application/vnd.ms-excel"}
          const elink = document.createElement("a");
          elink.download = "罗氏数据采集匿名数据.xlsx";
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click(); // 点击下载
          URL.revokeObjectURL(elink.href); // 释放URL的对象
          document.body.removeChild(elink);
          loading.close();
        })
        .catch((e) => {
          loading.close();
          this.$message.error("下载失败");
        });
    },
    handleSelectInput(date) {
      // this.date = j;
      this.month = moment(date[0]).format('YYYY-MM')
      this.endmonth = moment(date[1]).format('YYYY-MM')
    },
  },
};
</script>

<style scoped>
.header {
  border-bottom: 2px dotted rgb(231, 234, 236);
  padding-bottom: 20px;
}

.el-form {
  padding-bottom: 20px;
}

.el-form-item {
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/statement/components/LuoshiNimingExport.vue